import { HttpClient, HttpParams } from '@angular/common/http';
import {
  Component,
  ElementRef,
  HostListener,
  Input,
  ViewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { IApiResponse } from 'src/app/core/interfaces/api/api-response.interface';
import { IDynamicHeightComponent } from 'src/app/core/interfaces/common/ui/dynamic-height-component.interface';
import { PageContent } from 'src/app/core/models/common/page-content.model';
import { IAppState } from 'src/app/core/store/common/interfaces/app-state.interface';
import { applyUserProfileId } from 'src/app/core/ui-helpers/functions/user-context-url.func';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-tool-tip',
  templateUrl: './tool-tip.component.html',
  styleUrls: ['./tool-tip.component.scss'],
})
export class ToolTipComponent implements IDynamicHeightComponent {
  @Input() pageContent = new PageContent();
  isOpen = false;
  @ViewChild('tooltipContainer', { static: true }) tooltipContainer: ElementRef;
  hasUpvoted = false;
  hasDownvoted = false;

  constructor(
    private eRef: ElementRef,
    private httpClient: HttpClient,
    private store: Store<IAppState>,
  ) {
    this.pageContent.displayText = 'no clicks yet';
  }

  onClick() {
    this.isOpen = !this.isOpen;
  }

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (!this.eRef) return;
    // if user clicks outside the component
    if (this.isOpen && !this.eRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  setHeight(height: number): void {
    if (!this.tooltipContainer) return;
    this.tooltipContainer.nativeElement.style.height = `${height}px`;
  }

  upVote(): void {
    if (this.hasUpvoted) return;
    this.hasUpvoted = true;
    this.vote(true);
  }

  downVote(): void {
    if (this.hasDownvoted) return;
    this.hasDownvoted = true;
    this.vote(false);
  }

  async vote(feedback: boolean): Promise<void> {
    const body = {
      pageContentId: this.pageContent.id,
      feedback,
    };
    let params = new HttpParams();
    params = applyUserProfileId(params, this.store);
    const url = `${environment.apiUrl}Onboarding/Onboarding/navigation/page-content/tooltip-feedback`;
    firstValueFrom(this.httpClient.post<IApiResponse>(url, body, { params }));
  }
}
